export function replaceSentFromFormValues() {
    document.addEventListener("DOMContentLoaded", () => {
        const forms = document.querySelectorAll("form");

        forms.forEach((form) => {
            const hiddenInputs = form.querySelectorAll<HTMLInputElement>(
                'input[type="hidden"][value="sent_from_form"]'
            );

            hiddenInputs.forEach((input) => {
                // Determine Type
                const isOverlay = form.closest(".modal-form-block, .pricing-modal, .js-modal-form, .modal-form-content") !== null;
                const type = isOverlay ? "Overlay" : "Inline";

                // Determine Block or Page Name from class
                const block_page_Element = form.closest("[data-type-name]");
                let blockName = "unknown";
                if (block_page_Element) {
                    blockName = block_page_Element.getAttribute("data-type-name") || "unknown";
                }

                // Determine Position
                let position = "unknown";
                const main = form.closest("main");
                let isHero = false;

                if (main) {
                    let currentElement: HTMLElement | null = form;
                    while (currentElement && currentElement !== main) {
                        const classList = currentElement.classList;
                        if (
                            Array.from(classList).some(cls =>
                                cls.endsWith("-header") ||
                                cls.includes("__header") ||
                                cls === "section__header" ||
                                cls === "js-top-page-properties" ||
                                cls === "campaign-top-area"
                            )
                        ) {
                            isHero = true;
                            break;
                        }
                        currentElement = currentElement.parentElement;
                    }
                }

                if (isHero) {
                    position = "Hero";
                } else if (form.closest("header")) {
                    position = "Header";
                } else if (form.closest("footer")) {
                    position = "Footer";
                } else if (main) {
                    const formRect = form.getBoundingClientRect();
                    const mainRect = main.getBoundingClientRect();
                    const relativeY = formRect.top - mainRect.top;
                    const mainHeight = mainRect.height;

                    if (relativeY < mainHeight / 3) {
                        position = "Main-top";
                    } else if (relativeY < (2 * mainHeight) / 3) {
                        position = "Main-middle";
                    } else {
                        position = "Main-bottom";
                    }
                }

                // Set final value
                input.value = `${type}_${blockName}_${position}`;
            });
        });
    });
}
